import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";
import logo from "../../logo copy/teqa_connect__.png";

export default function WhyChoose() {
  const { t, isRTL } = useContext(LanguageContext);
  const reasons = t("whyChoose.reasons", { returnObjects: true }) || [];

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-indigo-50 py-24">
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl font-extrabold text-black">
            {t("whyChoose.title")}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {t("whyChoose.subtitle")}
          </p>
        </motion.div>

        {/* Content */}
        <div className="mt-16 grid grid-cols-1 gap-16 md:grid-cols-2 items-center">

          {/* Left list */}
          <div className="space-y-8">
            {reasons.map((reason, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: isRTL ? 40 : -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
              >
                <h3 className="text-lg font-semibold text-indigo-600">
                  {reason.title}
                </h3>
                <p className="mt-2 text-gray-600">
                  {reason.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Right illustration */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex items-center justify-center"
          >
            <div className="flex h-[380px] w-full max-w-lg items-center justify-center rounded-2xl">
              <img src={logo} alt="Teqa Connect illustration" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
